import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import AppIcon from "./AppIcon";

export default function AppHomeTools() {
  const [query, setQuery] = useState("");
  const navigate = useNavigate();
  const shortcuts = [
    ["/rental", "복합기 렌탈", "printer"], ["/store/toner-supplies", "토너 찾기", "toner"],
    ["/compare", "제품 비교", "compare"], ["/consultation?tab=general&type=as", "A/S 상담", "service"],
  ];
  return <section className="clone-home-tools" aria-label="제품 검색과 빠른 서비스">
    <form role="search" onSubmit={(event) => { event.preventDefault(); if (query.trim()) navigate(`/store?q=${encodeURIComponent(query.trim())}`); }}>
      <label htmlFor="clone-home-search">우리 사무실에 필요한 제품을 찾아보세요</label>
      <div className="clone-search-field">
        <input id="clone-home-search" value={query} onChange={(event) => setQuery(event.target.value)} placeholder="제품명, 모델명으로 검색" enterKeyHint="search" />
        <button type="submit" aria-label="제품 검색"><AppIcon name="search" size={22} /></button>
      </div>
    </form>
    <div className="clone-home-shortcuts">
      {shortcuts.map(([to, label, icon]) => <Link to={to} key={to}><span><AppIcon name={icon} size={26} /></span><strong>{label}</strong></Link>)}
    </div>
  </section>;
}
